import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(({ palette, spacing }) => ({
  header: {
    background: palette.primary.main,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: spacing(20, 20),
    width: '100%',
  },
  iconButton: { width: spacing(20), height: spacing(20) },
  buttons: {
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  icon: {
    width: spacing(20),
    height: spacing(20),
    '& .MuiSvgIcon-root': {
      width: spacing(20),
      height: spacing(20),
    },
    fill: 'white',
  },
  title: {
    color: '#fff',
    fontWeight: '500',
    fontSize: spacing(16),
    lineHeight: spacing(24),
    letterSpacing: spacing(-0.1),
  },
  content: {
    width: spacing(334),
    height: '100%',
    fontWeight: '400',
    fontSize: spacing(14),
    lineHeight: spacing(24),
    color: palette.gray[80],
    textAlign: 'center',
  },
  actions: {
    '&.MuiDialogActions-root': {
      padding: spacing(0, 40, 30, 40),
      justifyContent: 'center',
    },
  },
  button: {
    width: spacing(88),
  },
  textButton: {
    width: spacing(88),
    border: 'none',
    outline: 'none',
    backgroundColor: 'white',
    textTransform: 'uppercase',
    color: palette.gray[64],
  },
  textButtonActive: {
    marginLeft: 'auto',
    color: palette.primary.main,
    '&:hover': {
      background: 'white',
    },
  },
  editButton: {
    color: 'white',
    borderColor: 'white',
    marginRight: spacing(20),
  },
}))
